<template>
   <!-- 仮予約失敗 -->
  <ItemDialog ref="dialogRef" :initialOpen="false" :isDemand="true"  imageType="alert">
    <template v-slot:content-area>
      <h2>{{ errorTitle }}</h2>
      <p>{{ errorSubTitle }}</p>
    </template>

    <template v-slot:button-area>
      <ItemButton label="OK" actionType="btn-primary" @clicked="OK" />
    </template>
  </ItemDialog>
  <!-- 仮予約失敗 -->
</template>
<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "DialogErrorTentativeReservation",
  props:{
    errorCode:{
      type: String,
      require: true
    }
  },
  setup(props) {
    const router = useRouter();

    const dialogRef = ref(null);
    const openDialog = () => {
      dialogRef.value.open();
    };
    const closeDialog = () => {
      dialogRef.value.close();
    };

    const errorTitle = ref("仮予約に失敗しました")
    const errorSubTitle = ref(null)

    onMounted(async () => {
      switch (props.errorCode) {
        case "W002":
          errorSubTitle.value = "現在、対応可能な車両がないか、運行対象時間外となっております。なお、運行日は土休日等に限られていますのでご確認ください";
          break;
        case "W003":
          errorSubTitle.value = "現在、対応可能な車両がないか、運行対象時間外となっております。なお、運行日は土休日等に限られていますのでご確認ください";
          break;
        case "W_PICKUP_BUSSTOP_UNAVAILABLE":
          errorSubTitle.value = "乗車ができない場所が指定されています";
          break;
        case "W_DROPOFF_BUSSTOP_UNAVAILABLE":
          errorSubTitle.value = "降車ができない場所が指定されています";
          break;
        default:
          errorSubTitle.value = "予約ができませんでした";
          break;
      }
    })

    const OK = () =>{
      router.push({
        name: "DemandEbusBooking1",
      });
    }

    return {
      dialogRef,
      openDialog,
      closeDialog,
      errorTitle,
      errorSubTitle,
      OK,
    };
  },
};
</script>